"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocale = exports.LocaleContext = void 0;
var react_1 = require("react");
var en_US_1 = __importDefault(require("./locales/en-US"));
exports.LocaleContext = react_1.createContext(en_US_1.default);
function useLocale() {
    return react_1.useContext(exports.LocaleContext);
}
exports.useLocale = useLocale;
//# sourceMappingURL=LocaleContext.js.map